{
  "defaultTitle": "체크인할 수 없습니다",
  "defaultMessage": "배차 담당자에게 정보를 확인하거나 창고에 문의하세요",
  "backToHomescreen": "홈 화면으로 돌아가기",
  "hideErrorLog": "오류 로그 숨기기",
  "viewErrorLog": "오류 로그 보기",
  "errorLogMessageLabel": "메시지:",
  "errorLogStatusLabel": "상태 코드:",
  "unknown": "알 수 없음"
}
